import React from 'react'
import { DelimiterProps } from './intefaces/DelimiterProps';
import { DecimeterPosition } from './enums/position.enum';

const Delimiter: React.FC<DelimiterProps> = ({ className, position = DecimeterPosition.Horizontal }) => {
  const DEFAULT_DELIMITER_HORIZONTAL_CLASSNAME = 'h-[1px] bg-foggy-mist';
  const DEFAULT_DELIMITER_VERTICAL_CLASSNAME = 'w-[1px] bg-foggy-mist';

  if (position === DecimeterPosition.Horizontal) {
    return (
      <div className={`c-delimiter c-delimiter_horizontal w-full ${className ?? DEFAULT_DELIMITER_HORIZONTAL_CLASSNAME}`} />
    )
  }

  return (
    <div className={`c-delimiter c-delimiter_vertical h-full ${className ?? DEFAULT_DELIMITER_VERTICAL_CLASSNAME}`} />
  )
};

export default Delimiter;